import { render, staticRenderFns } from "./open-close.vue?vue&type=template&id=782eabd7&scoped=true"
import script from "./open-close.ts?vue&type=script&lang=ts&external"
export * from "./open-close.ts?vue&type=script&lang=ts&external"
import style0 from "./open-close.less?vue&type=style&index=0&id=782eabd7&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782eabd7",
  null
  
)

export default component.exports